var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4C(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 989 774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 469.697,
    y1: 411.407,
    x2: 470.408,
    y2: 412.315,
    gradientTransform: "matrix(987.4 0 0 -772.7 -463607.219 318715.281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f29102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff008c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M855.8 413c-22.9 48.3-72.2 81.7-129.2 81.7-79 0-143-64-143-143s64-143 143-143c57 0 106.3 33.4 129.2 81.7h132.4C960.4 171.6 853.8 83.1 726.5 83.1c-79 0-150.1 34.1-199.2 88.4V.9L.8 527.3v122.6h403.9v123.7h122.6V531.9c49.2 54.3 120.2 88.4 199.2 88.4 127.3 0 233.9-88.5 261.6-207.4H855.8v.1zM174.2 527.3l339.6-339.6c-35 45.4-55.9 102.3-55.9 164 0 67.1 24.6 128.5 65.3 175.6h-349z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4C);
export default __webpack_public_path__ + "static/media/4C.2acac97942f4c5cb84e63eaf4e3daeb5.svg";
export { ForwardRef as ReactComponent };